var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"sidebar-i--lg",class:{ active: _vm.isActive },attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.$emit('toggle')}}},[(_vm.icon)?_c('i',{class:_vm.icon}):_c('span',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }